<template>
  <div>
    <transferenceManagebar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดผู้ยื่นย้าย (ประมวลผลแบบที่ 1)"
      >
        <v-row dense class="align-center">
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              dense
              return-object
              hide-details
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 3 }} คอลัมน์)</span
                >
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group
              v-model="position"
              @change="positionSearch()"
              row
              hide-details
              class="mt-0"
            >
              <v-radio
                label="ผู้อำนวยการวิทยาลัย"
                value="ผู้อำนวยการวิทยาลัย"
              ></v-radio>
              <v-radio
                label="รองผู้อำนวยการวิทยาลัย"
                value="รองผู้อำนวยการวิทยาลัย"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
              single-line
              hide-details
              dense
              filled
            />
          </v-col>
          <v-col cols="12" md="1" class="text-md-right">
            <v-btn small rounded color="success" dark @click="exportToExcel">
              <v-icon left small>mdi-file-excel</v-icon>Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="showHeaders"
          :items="transference_manage_locations"
          :search="search"
          :loading="loading"
          group-by="manage_id_ref"
          item-key="manage_location_id_tfl"
          disable-pagination
          hide-default-footer
          class="mt-2"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <td :colspan="showHeaders.length" @click="toggle" style="cursor:pointer;">
              <v-icon>{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
              <strong class="ml-1">{{ items[0].manage_name }}</strong>
              <span class="grey--text ml-2"
                >Ref: {{ items[0].manage_id_ref }} — สังกัดปัจจุบัน:
                {{ items[0].college_name_now }}</span
              >
            </td>
          </template>

          <template v-slot:item.manage_case_move="{ item }">
            <v-chip v-if="item.manage_case_move === 'normal'" color="primary" small
              >ปกติ</v-chip
            >
            <v-chip v-if="item.manage_case_move === 'quality'" color="info" small
              >คุณภาพ</v-chip
            >
            <v-chip v-if="item.manage_case_move === 'special'" color="warning" small
              >กรณีพิเศษ</v-chip
            >
          </template>

          <template v-slot:item.college_name="{ item }">
            <v-chip small>
              <span style="font-size:14px;">{{ item.college_name }}</span>
            </v-chip>
          </template>

          <!-- ตำแหน่งว่างที่ปลายทาง ตามกรอบอัตรากำลัง jor18 (ตำแหน่งเดียวกับผู้ขอย้าย) -->
          <template v-slot:item.jor18_vacant_count="{ item }">
            <v-chip small :color="item.jor18_vacant_count > 0 ? 'green' : 'grey'" dark>
              {{ item.jor18_vacant_count }} ตำแหน่ง
            </v-chip>
          </template>

          <!-- ความเห็นสถานศึกษาปลายทาง: คลิก chip เปิด PDF Dialog -->
          <template v-slot:item.Mcommittee="{ item }">
            <v-chip
              v-if="item.Mcommittee === 'approp'"
              color="green"
              dark
              small
              style="cursor:pointer;"
              @click.stop="openPdfDialog(item)"
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>เห็นควรให้รับย้าย
            </v-chip>
            <v-chip
              v-else-if="item.Mcommittee === 'inapprop'"
              color="warning"
              dark
              small
              style="cursor:pointer;"
              @click.stop="openPdfDialog(item)"
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>ไม่เห็นควรให้รับย้าย
            </v-chip>
            <span v-else class="grey--text caption">ยังไม่ให้ความเห็น</span>
          </template>

          <!-- มอบหมายตำแหน่งด้วยมือ / ยกเลิกการมอบหมาย -->
          <template v-slot:item.assign_action="{ item }">
            <v-icon
              v-if="item.succ_college >= 1"
              color="red"
              @click.stop="deletePosition(item.manage_id_ref)"
              >mdi-delete-circle</v-icon
            >
            <v-icon
              v-else
              color="amber darken-2"
              @click.stop="
                select_idPosition(item.manage_id_ref, item.manage_location_id_tfl)
              "
              >mdi-credit-card-plus</v-icon
            >
          </template>

          <template v-slot:item.college_name_suss="{ item }">
            <v-chip v-if="item.college_name_suss" color="green" dark small>
              {{ item.college_name_suss }}
            </v-chip>
          </template>

          <!-- ยกเลิกความเห็นที่บันทึกไว้ -->
          <template v-slot:item.cancel_opinion="{ item }">
            <v-icon
              v-if="item.Mcommittee"
              color="red"
              @click="cancelDocument(item.manage_location_id_tfl)"
              >mdi-delete</v-icon
            >
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- Dialog: ดูไฟล์แนบ PDF ความคิดเห็น -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfDialog" max-width="90%" @click:outside="closePdfDialog">
          <v-card>
            <v-toolbar dense flat color="blue-grey darken-3" dark>
              <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
              <v-toolbar-title class="subtitle-1">
                ไฟล์ผลการพิจารณา —
                <span v-if="pdfItem">{{ pdfItem.manage_name }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <span v-if="pdfItem" class="caption mr-3 grey--text text--lighten-2">
                {{ pdfItem.MdocumentsLinkfile }}
              </span>
              <v-btn icon :href="pdfUrl" target="_blank" title="เปิดในแท็บใหม่">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn icon @click="closePdfDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="pa-2 pb-0" v-if="pdfItem">
              <v-row dense align="center">
                <v-col cols="12" md="3">
                  <span class="caption grey--text">รหัสอ้างอิง:</span>
                  <strong class="ml-1">{{ pdfItem.manage_id_ref }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">สถานศึกษาปัจจุบัน:</span>
                  <strong class="ml-1">{{ pdfItem.college_name_now }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">สถานศึกษาปลายทาง:</span>
                  <strong class="ml-1">{{ pdfItem.college_name }}</strong>
                </v-col>
                <v-col cols="12" md="3">
                  <span class="caption grey--text">ความคิดเห็น:</span>
                  <v-chip
                    x-small
                    dark
                    class="ml-1"
                    :color="pdfItem.Mcommittee === 'approp' ? 'green' : 'warning'"
                  >
                    {{
                      pdfItem.Mcommittee === "approp"
                        ? "เห็นควรให้รับย้าย"
                        : "ไม่เห็นควรให้รับย้าย"
                    }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text class="pa-0" style="height:78vh;">
              <iframe
                v-if="pdfDialog && pdfUrl"
                :src="pdfUrl"
                width="100%"
                height="100%"
                style="border:none; display:block;"
                type="application/pdf"
              >
                <v-alert type="warning" class="ma-4">
                  เบราว์เซอร์ของคุณไม่รองรับการแสดงผล PDF โดยตรง
                  <v-btn text color="primary" :href="pdfUrl" target="_blank"
                    >คลิกเพื่อเปิดไฟล์</v-btn
                  >
                </v-alert>
              </iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog: มอบหมายตำแหน่ง -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="เลือกตำแหน่ง"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <h4>รหัสอ้างอิง : {{ transference_manages_id_ref.manage_id_ref }}</h4>
                      รหัสบัตรประชาชน : {{ transference_manages_id_ref.id_card }}
                      <h4>
                        ชื่อ-นามสกุล :
                        {{ transference_manages_id_ref.title_s
                        }}{{ transference_manages_id_ref.frist_name }}
                        {{ transference_manages_id_ref.last_name }}
                        สถานศึกษาปัจจุบัน :
                        {{ transference_manages_id_ref.college_code }}
                        {{ transference_manages_id_ref.college_name_now }}
                        เลขที่ตำแหน่งปัจจุบัน :
                        {{ transference_manages_id_ref.id_position }}
                      </h4>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="2" class="pa-2">
                        <h3>เหตุผลในการย้าย :</h3>
                        <h4>{{ transference_manage_location_s.manage_reason_detail }}</h4>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="2" class="pa-2">
                        <div class="text-center">
                          <h2>
                            {{ transference_manage_location_s.manage_location_college_code }}
                            : {{ transference_manage_location_s.college_name }}
                          </h2>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="2" class="pa-2">
                        <v-autocomplete
                          prepend-icon="mdi-account-details"
                          :items="man_powers"
                          item-text="college_position_case"
                          item-value="id_position"
                          label="เลขที่ตำแหน่ง"
                          v-model="updatepositions.id_position"
                          outlined
                          required
                          :rules="[v => !!v || 'กรุณาเลือกเลขที่ตำแหน่ง']"
                        ></v-autocomplete>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn large color="green" @click.stop="updatepositionSubmit()" rounded>
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog ยืนยันรหัสผ่านร่วม: ใช้ทั้งยกเลิกความเห็นและยกเลิกการมอบหมายตำแหน่ง -->
      <v-layout row justify-center>
        <v-dialog v-model="cancelDialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              :title="cancelMode === 'opinion' ? 'ยกเลิกความเห็นสถานศึกษาปลายทาง' : 'ยกเลิกการมอบหมายตำแหน่ง'"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12 v-if="cancelMode === 'opinion'">
                      <h3>รหัสอ้างอิง : {{ manage_location_id_tfls.manage_id_ref }}</h3>
                      รหัสบัตรประชาชน : {{ manage_location_id_tfls.id_card }}
                      <h3>
                        ชื่อ-นามสกุล :
                        {{ manage_location_id_tfls.title_s
                        }}{{ manage_location_id_tfls.frist_name }}
                        {{ manage_location_id_tfls.last_name }}
                      </h3>
                      สถานศึกษาปลายทางที่พิจารณา : {{ manage_location_id_tfls.college_name }}
                    </v-flex>
                    <v-flex md12 v-else>
                      <h3>รหัสอ้างอิง : {{ transference_manages_id_ref.manage_id_ref }}</h3>
                      รหัสบัตรประชาชน : {{ transference_manages_id_ref.id_card }}
                      <h3>
                        ชื่อ-นามสกุล :
                        {{ transference_manages_id_ref.title_s
                        }}{{ transference_manages_id_ref.frist_name }}
                        {{ transference_manages_id_ref.last_name }}
                      </h3>
                      วิทยาลัยปลายทางที่จะยกเลิก : {{ man_powerss.college_name || "สับเปลี่ยนตำแหน่ง" }}
                      เลขที่ตำแหน่ง : {{ man_powerss.id_position || "-" }}
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        v-model="cancelPassword"
                        filled
                        rounded
                        type="password"
                        label="Password"
                        :rules="[v => !!v || 'กรุณากรอก Password']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="cancelDialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ปิด
              </v-btn>
              <v-btn large color="red" @click.stop="cancelSubmit()" rounded>
                <v-icon dark>mdi-pencil</v-icon>&nbsp;ยืนยันยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar v-model="snackbar.show" top :timeout="snackbar.timeout" :color="snackbar.color">
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import transferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx";

export default {
  components: { transferenceManagebar },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      transference_manage_locations: [],
      search: "",
      position: "",
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ลำดับที่ขอย้าย", align: "center", value: "manage_location_sequence_n" },
        { text: "กรณี", align: "center", value: "manage_case_move" },
        { text: "Ref", align: "center", value: "manage_id_ref" },
        { text: "ผู้ขอย้าย", align: "left", value: "manage_name" },
        { text: "ตำแหน่งปัจจุบัน", align: "left", value: "position_name" },
        { text: "เลขที่ตำแหน่งปัจจุบัน", align: "center", value: "id_position" },
        { text: "สังกัดปัจจุบัน", align: "left", value: "college_name_now" },
        { text: "อายุงาน", align: "center", value: "manage_age_app_time" },
        { text: "สถานศึกษาที่ขอย้ายไป", align: "left", value: "college_name" },
        { text: "ตำแหน่งว่างปลายทาง (jor18)", align: "center", value: "jor18_vacant_count" },
        { text: "ความเห็นผู้บังคับบัญชา", align: "center", value: "manage_comment_supervisor" },
        { text: "ความเห็นสถานศึกษาปลายทาง", align: "center", value: "Mcommittee", sortable: false },
        { text: "มอบหมายตำแหน่ง", align: "center", value: "assign_action", sortable: false },
        { text: "รหัสตำแหน่งใหม่", align: "center", value: "id_position_new" },
        { text: "วิทยาลัยแห่งใหม่", align: "left", value: "college_name_suss" },
        { text: "ยกเลิกความเห็น", align: "center", value: "cancel_opinion", sortable: false }
      ],
      periods: [],
      period_enable_process: "1",

      // PDF Dialog (ดูความเห็นสถานศึกษาปลายทาง)
      pdfDialog: false,
      pdfItem: null,
      pdfUrl: "",

      // มอบหมายตำแหน่งด้วยมือ
      positiondialog: false,
      transference_manages_id_ref: {},
      transference_manage_location_s: {},
      updatepositions: {},
      updatepositions_condition: {},
      addreturn_man_power: {},
      man_powers: [],

      // ยกเลิก (ใช้ dialog/รหัสผ่านร่วมกันทั้งสองกรณี)
      cancelDialog: false,
      cancelMode: "opinion", // 'opinion' | 'assignment'
      cancelPassword: "",
      manage_location_id_tfls: {},
      man_powerss: {},
      conditons_transfer_successs: {},
      man_power_cancel: {},

      data_syslog: {}
    };
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery();
    await this.transference_manage_locationQueryAll();
  },

  methods: {
    async periodQuery() {
      let result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_type: "manage",
        periord_admin: "check"
      });
      this.periods = result_period.data;
    },

    sortByApplicantThenSequence(rows) {
      return [...rows].sort((a, b) => {
        if (a.manage_id_ref !== b.manage_id_ref) {
          return String(a.manage_id_ref).localeCompare(String(b.manage_id_ref));
        }
        return (a.manage_location_sequence_n || 0) - (b.manage_location_sequence_n || 0);
      });
    },

    async transference_manage_locationQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          mode: "list_period",
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = this.sortByApplicantThenSequence(result.data);
    },

    async positionSearch() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          mode: "by_position",
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year,
          manage_location_position: this.position
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = this.sortByApplicantThenSequence(result.data);
    },

    exportToExcel() {
      try {
        const data = this.transference_manage_locations.map(item => {
          const row = {};
          this.showHeaders.forEach(h => {
            if (h.sortable === false) return;
            const val = item[h.value];
            row[h.text] = val !== null && val !== undefined && val !== "" ? val : "-";
          });
          return row;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Manage_Location");

        const filename = `รายละเอียดผู้ยื่นย้ายสายบริหาร_${this.periods.period_times}_${this.periods.period_year}.xlsx`;
        XLSX.writeFile(wb, filename);

        this.snackbar = {
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          text: "ส่งออกไฟล์ Excel เรียบร้อย"
        };
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.snackbar = {
          show: true,
          color: "error",
          icon: "mdi-alert-circle",
          text: "เกิดข้อผิดพลาดในการส่งออก"
        };
      }
    },

    /** เปิด Dialog ดู PDF ความคิดเห็นของสถานศึกษาปลายทาง */
    openPdfDialog(item) {
      if (!item.MdocumentsLinkfile) {
        this.snackbar = {
          show: true,
          color: "warning",
          timeout: 3000,
          icon: "mdi-alert",
          text: "ไม่พบไฟล์แนบสำหรับรายการนี้"
        };
        return;
      }
      this.pdfItem = item;
      this.pdfUrl = "/HRvecfiles/" + item.MdocumentsLinkfile;
      this.pdfDialog = true;
    },

    closePdfDialog() {
      this.pdfDialog = false;
      this.pdfItem = null;
      this.pdfUrl = "";
    },

    /** เปิด dialog มอบหมายตำแหน่งด้วยมือ พร้อมดึงตำแหน่งว่างของวิทยาลัยปลายทางมาให้เลือกจริง */
    async select_idPosition(manage_id_ref, manage_location_id_tfl) {
      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;

      let result = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        mode: "by_tfl",
        manage_location_id_tfl: manage_location_id_tfl
      });
      this.transference_manage_location_s = result.data;

      let result_mp = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        college_code: this.transference_manage_location_s.manage_location_college_code
      });
      this.man_powers = result_mp.data;

      this.updatepositions = {};
      this.positiondialog = true;
    },

    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        const applicant = this.transference_manages_id_ref;
        const destination = this.transference_manage_location_s;

        this.addreturn_man_power = {
          ApiKey: this.ApiKey,
          college_code: applicant.college_code,
          id_position: applicant.id_position,
          position: applicant.position_name,
          case_vacancy: "ย้ายรอบ-" + applicant.time_ss + "/" + applicant.year_ss
        };

        this.updatepositions_condition = {
          ApiKey: this.ApiKey,
          id_position: this.updatepositions.id_position,
          status_booking: applicant.id_card
        };

        // ฟิลด์ต้องตรงกับที่ conditons_transfer_success.insert.php อ่าน (ctsxxx) เท่านั้น
        const ctsPayload = {
          ApiKey: this.ApiKey,
          ctsid_ref: applicant.manage_id_ref,
          ctstime_s: applicant.time_ss,
          ctsyear_s: applicant.year_ss,
          ctsid_postion_old: applicant.id_position,
          ctscollege_code_old: applicant.college_code,
          ctscollege_code: destination.manage_location_college_code,
          ctsid_card: applicant.id_card,
          ctsid_position: this.updatepositions.id_position,
          ctsname_position: applicant.position_name,
          ctsstatus_select: "demand"
        };

        let result_man_return = await this.$http.post(
          "man_power.insert.php",
          this.addreturn_man_power
        );

        if (result_man_return.data.status == true) {
          let result_man = await this.$http.post(
            "man_power.update_process.php",
            this.updatepositions_condition
          );

          let result = await this.$http.post(
            "conditons_transfer_success.insert.php",
            ctsPayload
          );

          if (result_man.data.status == true && result.data.status == true) {
            await this.logAction("manualAssign", "conditons_transfer_success", applicant.manage_id_ref);
            this.snackbar = {
              show: true,
              color: "success",
              icon: "mdi-check-circle",
              text: "บันทึกข้อมูลเรียบร้อย"
            };
            this.transference_manage_locationQueryAll();
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.positiondialog = false;
      }
    },

    /** เปิด dialog ยกเลิกความเห็นสถานศึกษาปลายทาง */
    async cancelDocument(manage_location_id_tfl) {
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          mode: "by_tfl",
          manage_location_id_tfl: manage_location_id_tfl
        })
        .finally(() => (this.loading = false));
      this.manage_location_id_tfls = result.data;
      this.cancelMode = "opinion";
      this.cancelPassword = "";
      this.cancelDialog = true;
    },

    /** เปิด dialog ยกเลิกการมอบหมายตำแหน่ง */
    async deletePosition(manage_id_ref) {
      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;

      let result_man = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_manages_id_ref.id_card
      });
      this.man_powerss = result_man.data;

      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.conditons_transfer_successs = result_cts.data;

      this.cancelMode = "assignment";
      this.cancelPassword = "";
      this.cancelDialog = true;
    },

    /** ยืนยันรหัสผ่านร่วม แล้วดำเนินการยกเลิกตาม cancelMode */
    async cancelSubmit() {
      if (!this.$refs.cancelform.validate()) return;

      if (this.cancelPassword !== "Th07111988@1") {
        this.snackbar = {
          show: true,
          color: "error",
          timeout: 3000,
          icon: "mdi-lock-alert",
          text: "Password ไม่ถูกต้อง"
        };
        return;
      }

      if (this.cancelMode === "opinion") {
        await this.cancelOpinion();
      } else {
        await this.cancelAssignment();
      }
      this.cancelDialog = false;
    },

    async cancelOpinion() {
      this.manage_location_id_tfls.ApiKey = this.ApiKey;
      this.manage_location_id_tfls.Mcommittee = "";
      this.manage_location_id_tfls.MdocumentsLinkfile = "";

      let result = await this.$http.post(
        "transference_manage_location.admincancel.update.php",
        this.manage_location_id_tfls
      );

      await this.$http.post("deletefile.php", {
        ApiKey: this.ApiKey,
        filename: "../HRvecfiles/" + this.manage_location_id_tfls.MdocumentsLinkfile
      });

      if (result.data.status == true) {
        Swal.fire({ icon: "success", title: "ดำเนินการลบข้อมูลเรียบร้อย", showConfirmButton: false, timer: 1500 });
        await this.logAction("cancelDocument", "transference_manage_location", this.manage_location_id_tfls.manage_id_ref);
        this.transference_manage_locationQueryAll();
      } else {
        Swal.fire({ icon: "warning", title: "ดำเนินการลบผิดพลาด", showConfirmButton: false, timer: 1500 });
      }
    },

    async cancelAssignment() {
      this.man_powerss.ApiKey = this.ApiKey;
      this.man_powerss.status_booking = "";

      this.conditons_transfer_successs.ApiKey = this.ApiKey;

      this.man_power_cancel = {
        ApiKey: this.ApiKey,
        id_position: this.conditons_transfer_successs.id_postion_old
      };

      let result_man = await this.$http.post("man_power.update_process.php", this.man_powerss);
      let result_man_delete = await this.$http.post("man_power.delete.php", this.man_power_cancel);
      let result_cts = await this.$http.post(
        "conditons_transfer_success.delete.php",
        this.conditons_transfer_successs
      );

      if (
        result_man.data.status == true &&
        result_cts.data.status == true &&
        result_man_delete.data.status == true
      ) {
        await this.logAction(
          "manualCancel",
          "conditons_transfer_success",
          this.transference_manages_id_ref.manage_id_ref
        );
        this.snackbar = { show: true, color: "success", icon: "mdi-check-circle", text: "ยกเลิกข้อมูลเรียบร้อย" };
        this.transference_manage_locationQueryAll();
      } else {
        this.snackbar = { show: true, color: "error", icon: "mdi-close-network", text: "ยกเลิกข้อมูลผิดพลาด" };
      }
    },

    async logAction(event_log, table_log, detail_log) {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.data_syslog = {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name,
        event_log: event_log,
        page_log: "transference_manage_location_review",
        table_log: table_log,
        detail_log: detail_log,
        date_times: this.date_today_log
      };
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    }
  },

  computed: {
    period_years() {
      return this.periods.period_year;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + "/" + time;
    }
  }
};
</script>
